import './styles.scss';
import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useParams, Outlet } from "react-router-dom";
import Skeleton from 'react-loading-skeleton';

import { Fade } from 'react-awesome-reveal';
import $ from 'jquery';
import { removeBaseUrl } from '../../utils';

const SinglePAPage = () => {
    const { slug } = useParams();
    const [isFetching, setIsFetching] = useState(true);
    const [pageContent, setPageContent] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        // document.title = "Wood Edwards";
        fetchPostContent(slug);

        return (() => {})
    }, [slug]);

    const fetchPostContent = async (slug) => {
        setIsFetching(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&slug=${slug}&page_name=practice_area`);

            setPageContent(data?.page ?? null);
            // if (data?.page?.yoast_title?.length > 0) {
            //     document.title = data?.page?.yoast_title;
            // } else {
            //     if (data?.page?.page?.post_title) {
            //         document.title = data?.page?.page?.post_title;
            //     }
            // }

            const postId = data?.page?.page?.ID;
            if (document.querySelector('#wp-admin-bar-edit a') && postId) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${postId}&action=edit`;
            }


            setTimeout(() => {
                $("#table-of-contents").html("");
                var toc = $("#table-of-contents");
                var lastLevel = 2; // Assuming the first heading level is H2
            
                $(".main-content h2, .main-content h3").each(function(index) {
                    var heading = $(this);
                    var headingText = heading.text();
                    var anchor = headingText.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/\s+/g, '-').toLowerCase();

                    heading.attr('id', anchor);
                    var level = parseInt(this.tagName.substring(1));
                    
                    if (level > lastLevel) {
                        // Start a new sublist
                        var sublist = $("<ul>");
                        toc.find('li:last').append(sublist);
                        toc = sublist;
                    } else if (level < lastLevel) {
                        // End current sublist(s)
                        toc = toc.parents('ul').last();
                    }
                    
                    lastLevel = level;
                    if (anchor?.length > 1) {
                        var listItem = $('<li>').appendTo(toc);
                        listItem.append($('<a>').attr('href', '#' + anchor).text(headingText));
                    }

                    $('#table-of-contents a').on('click', function (e) {
                        let elementId = $(this).attr('href');
    
                        var elementTop = $(elementId).offset()?.top ?? 0;
                        var viewportHeight = $(window).height();
                        var newScrollTop = elementTop - (viewportHeight / 2);
                      
                        window.scrollTo({ top: newScrollTop, behavior: 'smooth' })
                        e.stopPropagation();
                        return false;
                    });
                });
            }, 600);

            window.addEventListener('scroll', highlightActiveItem);
            
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    }

    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    const highlightActiveItem = () => {
        var headings = $("h2, h3");
        var tocLinks = $("#table-of-contents a");
        
        headings.each(function(index) {
            if (isElementInViewport(this)) {
                tocLinks.removeClass("active");
                var currentAnchor = $(this).attr("id");
                tocLinks.filter("[href='#" + currentAnchor + "']").addClass("active");
            }
        });
    }


    const generateRandomWidth = () => {
        // Generate a random width between 50% and 100%
        return `${Math.floor(Math.random() * 51) + 50}%`;
    };

    
    return <Fade delay={1}>
        <div className='single-pa-page'>
            <section id="banner" className='single-pa-banner'>
                <div className='inner-wrapper'>
                    <div className='banner-area'>
                        <span className='tag'>
                            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="5" cy="5" r="5" fill="#037C8E"/>
                            </svg>
                            Practice Areas
                        </span>
                        {isFetching && <h1><Skeleton width={"100%"} /></h1>}
                        {!isFetching && <h1>{pageContent?.banner?.title}</h1>}
                    </div>
                </div>
            </section>

            <section id="single-pa-details-container">
                <div className='single-pa-sidebar-wrapper'>
                    {!isFetching && <div className='main-content' dangerouslySetInnerHTML={{__html: pageContent?.page?.post_content}}></div>}
                    {
                        isFetching && <div className='main-content'>
                            {Array.from({length: 30}).map(it => <Skeleton width={generateRandomWidth()} height="20px" key={it} style={{marginTop: "5px"}} />)}
                        </div>
                    }
                    <aside className={`sidebar ${pageContent?.featured_image ? "has-featured-image" : ""}`}>
                        {!isFetching && pageContent?.featured_image && <div className='featured-image' dangerouslySetInnerHTML={{__html: pageContent?.featured_image}}>

                        </div>}
                        {
                            isFetching && <div className='featured-image'>
                                <Skeleton width="100%" height="300px" />
                            </div>
                        }
                        {!isFetching && <div className='toc-wrapper'>
                            <span className='title'>Page Contents</span>
                            <ul id="table-of-contents">
                                
                            </ul> 
                        </div>}
                        {
                        isFetching && <div className='toc-wrapper'>
                                <span className='title'><Skeleton width="100%" /></span>
                                <ul id="table-of-contents">
                                    {Array.from({length: 5}).map(it => <Skeleton width={generateRandomWidth()} height="20px" key={it} style={{marginTop: "5px"}} />)}
                                </ul> 
                            </div>
                        }
                    </aside>
                </div>
            </section>

            {
                pageContent?.attorneys?.attorneys?.length > 0 && <section id="attorneys-section">
                    <div className='inner-wrapper'>
                        <h2>{pageContent?.attorneys?.title ? pageContent?.attorneys?.title : 'Meet the Attorneys'}</h2>
                        <div className='attorneys-repeater'>
                            {
                                pageContent?.attorneys?.attorneys?.map((it, index) => <div className='attorney-box' key={index}>
                                    <div className='block-photo'>
                                        <img src={it?.head_shot} />
                                    </div>
                                    <div className='block-details'>
                                        <span className='name'>{it?.name}</span>
                                        <div className='details' dangerouslySetInnerHTML={{__html: it?.bio_content}}></div>
                                        <div className='block-links'>
                                            <Link to={it?.bio_url}>View Bio</Link>
                                            {it?.phone_number && <a href={`tel:${it?.phone_number}`}>{it?.phone_number}</a>}
                                            <a href={`mailto:${it?.email}`}>{it?.email}</a>
                                        </div>
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                </section>
            }

            {isFetching || pageContent?.posted_articles?.articles?.length > 0 && <section id="posted-articles-section">
                <div className='inner-wrapper'>
                    <div id="section-header">
                        <h2>Related Articles</h2>
                        <Link to="/articles/" className='button'>Browse All Articles</Link>
                    </div>

                    <div className="posts-wrapper">
                        <div className='posts-repeater'>
                            {
                                pageContent?.posted_articles?.articles?.map((it, index) => {
                                    return <div className='blog-item' key={index}>
                                        <Link to={removeBaseUrl(it?.permalink)} className='blog-title'>
                                            {it?.title}
                                        </Link>
                                        <div className='blog-meta'>
                                            <span className='author'>By {it?.author_name}</span>
                                            <span className='category'>
                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5" cy="5" r="5" fill="#024953"/>
                                                </svg>
                                                {it?.category?.name}
                                            </span>
                                        </div>
                                        <span className='excerpt'>
                                            {it?.excerpt?.length > 100 ? `${it?.excerpt?.substring(0, 100)}...` : it.excerpt} <Link to={removeBaseUrl(it?.permalink)}>Read more</Link>
                                        </span>
                                    </div>
                                })
                            }
                        </div>
                    </div>

                </div>
            </section>}
        </div>
    </Fade>
}

export default SinglePAPage;